import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'

import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { BannerInfo } from './BannerInfo/BannerInfo'
import { CareerSteps } from './CareerSteps/CareerSteps'

import { TRANSLATION } from './constants'
import * as Styles from './styles'
import coachImage from './assets/image.png'
import coachImageMobile from './assets/image-mobile.png'

export const CoachBanner = () => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()

  useEffect(() => {
    trackInternalEvent('see_coaching_promo')
  }, [])

  return (
    <Styles.Container>
      <Styles.BannerContainer>
        <BannerInfo />
      </Styles.BannerContainer>
      <Styles.InfoContainer>
        <Styles.Title>{i18n.t(`${TRANSLATION}.header`)}</Styles.Title>
        <Styles.Description
          dangerouslySetInnerHTML={{ __html: i18n.t(`${TRANSLATION}.sub_header`) }}
        />
      </Styles.InfoContainer>
      <Styles.ImageContainer>
        <Styles.Image src={isPhone ? coachImageMobile : coachImage} alt="Coach image" />
      </Styles.ImageContainer>
      <CareerSteps />
    </Styles.Container>
  )
}
